import { render } from "./RequestForm.vue?vue&type=template&id=a10de7de&ts=true"
import script from "./RequestForm.vue?vue&type=script&lang=ts"
export * from "./RequestForm.vue?vue&type=script&lang=ts"

import exportComponent from "/home/runner/work/SPINcrs-demo/SPINcrs-demo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__